"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfigLoader = void 0;
const timers_1 = require("./timers");
const SECONDS_PER_MINUTE = 60;
const DEFAULT_CONFIG_REFRESH_MINUTES = 10; // minimum minutes until configuration is refreshed
const DEFAULT_CONFIG_REFRESH_SECONDS = DEFAULT_CONFIG_REFRESH_MINUTES * SECONDS_PER_MINUTE;
/**
 * Deadline implements a simple timer reporting when it's time to refresh config.
 */
class Deadline {
    constructor(intervalMs) {
        this.start = Date.now();
        this.interval = intervalMs;
    }
    /**
     * Return true if the deadline has passed.
     *
     * @returns {boolean} isPassed
     */
    isPassed() {
        if (this.deltaNow() > this.interval) {
            this.reset();
            return true;
        }
        return false;
    }
    deltaNow() {
        const now = Date.now();
        return now - this.start;
    }
    reset() {
        this.start = Date.now();
    }
}
/**
 * Return an async "getConfig" function that loads config from the provided
 * callback function.
 *
 * @param {Function} loadConfigFn
 *
 * @returns {Function} getConfigFn
 */
function createConfigLoader({ loadConfigFn, refreshIntervalSeconds = DEFAULT_CONFIG_REFRESH_SECONDS, }) {
    const deadline = new Deadline(refreshIntervalSeconds * timers_1.MILLISECONDS_PER_SECOND);
    let config;
    return async () => {
        if (config && !deadline.isPassed()) {
            return config;
        }
        config = (async () => loadConfigFn())();
        return config;
    };
}
exports.createConfigLoader = createConfigLoader;
//# sourceMappingURL=config.js.map